import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/api/client";
import { useAuthStore } from "@/lib/auth/authStore";

export type DashboardNavBadgeKey =
  | "admin_approvals"
  | "ads_pending"
  | "appointments"
  | "billing_invoices"
  | "blog_interactions"
  | "businesses"
  | "cart"
  | "departments"
  | "family_requests"
  | "favorites"
  | "lab_orders"
  | "messages"
  | "notifications"
  | "orders"
  | "post_moderation"
  | "review_moderation"
  | "reports"
  | "security_events"
  | "services"
  | "staff_requests"
  | "superadmin_pending"
  | "event_reviews"
  | "event_interactions";

interface DashboardNavBadgesResponse {
  counts: Partial<Record<DashboardNavBadgeKey, number>>;
}

const EMPTY_BADGES: DashboardNavBadgesResponse = { counts: {} };

export const formatNavBadgeCount = (count: number): string => (count > 99 ? "99+" : String(count));

export const useNavBadges = (enabled = true) => {
  const accessToken = useAuthStore((state) => state.accessToken);
  const activeFunctionalAccount = useAuthStore((state) => state.activeFunctionalAccount);
  const hasBootstrapped = useAuthStore((state) => state.hasBootstrapped);

  return useQuery({
    queryKey: ["dashboard", "nav-badges", activeFunctionalAccount?.id ?? "none"],
    queryFn: async () => {
      const response = await apiClient.get<DashboardNavBadgesResponse>("/dashboard/nav-badges");
      return response.data;
    },
    enabled: enabled && Boolean(accessToken) && hasBootstrapped,
    retry: false,
    staleTime: 30_000,
    placeholderData: EMPTY_BADGES,
  });
};
